import React from 'react';
import {connect} from 'react-redux';

import {Typography} from '@mui/material';

import {createResource} from 'spectra-logic-ui/actions';
import {FormDialog} from 'spectra-logic-ui/components';
import {Dispatch} from 'spectra-logic-ui';

type Props = {
  account: string;
  onSubmit: (values: any) => Promise<any>;
}

const ClearIamUserCacheDialog = (props: any) => (
  <FormDialog title='Clear Cache' submitLabel='Clear Cache' {...props}>
    {() => (<Typography>Clear the current cache for all of the listed IAM users?</Typography>)}
  </FormDialog>
);

const mapDispatchToProps = (dispatch: Dispatch, {account}: Props) => {
  const resource = `accounts/${account}/clear_cache`;
  return {
    onSubmit: () => dispatch(createResource(resource)),
  };
};

export default connect(undefined, mapDispatchToProps)(ClearIamUserCacheDialog);
